export default __webpack_public_path__ + "images/work-life.ef56cd35b0e211d1931e2e20f7a9fa53.jpg";